// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"SharableProfile_buttonWrapper__lBhHk","mobileScreenButtonWrapper":"SharableProfile_mobileScreenButtonWrapper__dLwLh"};